/**
 * Kategorie souborů — musí zůstat v sync s BE enumem `BuildingFileCategory`
 * (backend/src/Module/Building/Domain/BuildingFile/Enum/BuildingFileCategory.php).
 * Každá kategorie platí buď pro celou budovu, nebo pro jednotku; 'other' pro obojí.
 * Popisky drží i18n klíč `Files.Category.<value>`.
 */

export const BUILDING_FILE_CATEGORIES = [
  'assembly_minutes',
  'founding_documents',
  'accounting',
  'supplier_contract',
  'building_inspection',
  'insurance',
  'house_rules',
  'other',
] as const;

export const UNIT_FILE_CATEGORIES = [
  'billing',
  'advance_payment',
  'meter_reading',
  'unit_inspection',
  'contract',
  'correspondence',
  'handover_protocol',
  'other',
] as const;

export type FileCategory = (typeof BUILDING_FILE_CATEGORIES)[number] | (typeof UNIT_FILE_CATEGORIES)[number];
